import { useMemo } from "react";
import { FCX, SuggestedSearches as PlatformSuggestedSearches } from "@datassential/platform-ui-lib";
import cn from "classnames";
import useCommonData from "@apiHooks/useCommonData";
import { excludeNullable, mapByKey, randomizeItems } from "@core/utils/array";

interface SuggestedSearchesProps {
    onSearchClick: (search: string) => void;
}

const SuggestedSearches: FCX<SuggestedSearchesProps> = ({ onSearchClick }) => {
    const { data, isLoading } = useCommonData();

    const suggestedSearches = useMemo(
        () => randomizeItems(
            excludeNullable(
                mapByKey(data?.suggestedSearches ?? [], 'text')
            ),
            3
        ),
        [data?.suggestedSearches]
    );

    if (isLoading || !suggestedSearches.length) return null;

    return (
        <PlatformSuggestedSearches
            className={cn(
                "ToolSearch__recent-searches",
                "ToolSearchRecentSearches",
                "appears-top",
                "fast"
            )}
            searches={suggestedSearches}
            title="Suggested Questions"
            onSearchClick={onSearchClick}
        />
    );
};

export default SuggestedSearches;